import React, {useState} from "react";
import {Dropdown, Heading, IconPlane16} from "pac-ux-components";
import useTenants from "../../hooks/useTenants";
import Loading from "../Loading";
import StoresList from "./StoresList";
import {useCookies} from "react-cookie";

function Stores() {
    const [selectedTenant, setSelectedTenant] = useState(null);
    const [stores, setStores] = useState(null);
    const {tenants, loading, error} = useTenants();
    const apiRoot = process.env.REACT_APP_API_ROOT_URL;
    const [cookies] = useCookies(['idToken']);
    const apiHeaders = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + cookies.idToken
    }

    if (loading) return (<Loading/>);

    const tenantOptions = tenants.map((tenant) => ({label: tenant.name, value: tenant.id}));

    const handleDropdownChange = async (e) => {
        const selected = tenants.find(tenant => tenant.id === e);
        setSelectedTenant(selected);
        await getStores(selected.id);
    }

    const getStores = async (storeId) => {
        try {
            const fetchAllPages = async (enabled) => {
                let allStores = [];
                let page = 0;
                let lastPage = false;

                while (!lastPage) {
                    const response = await fetch(`${apiRoot}/backoffice/tenants/${storeId}/stores?enabled=${enabled}&size=100&page=${page}`, {headers: apiHeaders});
                    const json = await response.json();
                    allStores = [...allStores, ...json.content];
                    lastPage = json.last;
                    page += 1;
                }

                return allStores;
            };

            const enabledStores = await fetchAllPages(true);
            const disabledStores = await fetchAllPages(false);

            const allStores = [...enabledStores, ...disabledStores];
            setStores(allStores);

        } catch (error) {
            console.error('Error fetching stores:', error);
        }
    };

    return (<div className="Stores" style={{width: 1047}}>
        <Heading color={'#10304C'} style={{paddingTop: 96, paddingBottom: 16}}>Stores</Heading>
        <div style={{}}>Select a tenant to edit the associated stores.</div>
        <Dropdown
            onChange={handleDropdownChange}
            style={{marginTop: 32, marginBottom: 32, width: 330}}
            label={<div><IconPlane16 style={{marginRight: 8}}/>Select a tenant</div>}
            options={tenantOptions}
            selected={selectedTenant}
            renderSelectedLabel={() => {
                return <div><IconPlane16 style={{marginRight: 8}}/>{selectedTenant.name}</div>
            }}
        />
        <div style={{float: 'right', textAlign: 'center', paddingBottom: '30px'}}><a href="/logs?table=stores"><img
            src="/image/history_icon.svg" width={24} height={23} alt={History}/></a></div>
        {Array.isArray(stores) && (
            <StoresList setStores={setStores} stores={stores} tenant={selectedTenant} getStores={async () => {
                await getStores(selectedTenant.id)
            }}/>)}


    </div>);
}

export default Stores;